import { mediaQueryLarge } from "@theme/utilities";

export class MobileDrawerButtonComponent extends HTMLElement {
    trigger = this.querySelector('[ref="trigger"]');

    drawer = this.querySelector('mobile-drawer');

    isOpen = false;
    
    constructor() {
        super();
        
        if (typeof $ !== 'function') {
            throw new Error('jQuery is not detected at MobileDrawerComponent');
        }

        if (!this.trigger) {
            throw new Error('[ref="trigger"] is not defined');
        }
    }

    connectedCallback() {
        this.#initEventListeners();
        mediaQueryLarge.addEventListener('change', this.close.bind(this));
    }

    disconnectedCallback() {
        this.#destroyEventListeners();
    }

    open() {
        const topOffset = this.overallHeaderHeight;
        $(this.drawer).css('top', `${topOffset}px`);
        $(this.drawer).css('height', `calc(100vh - ${topOffset}px)`);
        $(this.drawer).fadeIn(150);
        this.isOpen = true;
        this.trigger?.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    close() {
        $(this.drawer).fadeOut(150);
        this.isOpen = false;
        this.trigger?.classList.remove('active');
        document.body.style.overflow = 'auto';
    }

    /**
     * @param {PointerEvent} event
     * @returns {void}
     */
    #handleTriggerClick(event) {
        this.isOpen ? this.close() : this.open();
    }

    /**
     * @return {void}
     */
    #initEventListeners() {
        this.trigger?.addEventListener('click', this.#handleTriggerClick.bind(this));
    }

    /**
     * @returns {void}
     */
    #destroyEventListeners() {
        this.trigger?.removeEventListener('click', this.#handleTriggerClick.bind(this));
    }

    get overallHeaderHeight() {
        /** @type {HTMLElement|null} */
        let header = document.querySelector('#header-group');
        header = header?.querySelector('header') ?? null;
        return (header?.offsetHeight ?? 0) + (header?.getBoundingClientRect()?.top ?? 0);
    }
}

if (!customElements.get('mobile-drawer-button')) {
    customElements.define('mobile-drawer-button', MobileDrawerButtonComponent);
}

export class MobileDrawerComponent extends HTMLElement {
    static observedAttributes = ['style'];

    constructor() {
        super();
    }

    /**
     * @param {string} name 
     * @param {*} oldValue 
     * @param {*} newValue 
     */
    attributeChangedCallback(name, oldValue, newValue) {
        if (!newValue) {
            /**@type {MobileDrawerButtonComponent|null} */
            const button = document.querySelector('mobile-drawer-button');
            button?.close();
        }
    }
}

if (!customElements.get('mobile-drawer')) {
    customElements.define('mobile-drawer', MobileDrawerComponent);
}
